(() => {
  const formatMoney = (amount, currency) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format((Number(amount) || 0) / 100);
    } catch (_) {
      return `$${((Number(amount) || 0) / 100).toFixed(2)}`;
    }
  };

  const replaceMainImage = (root, src, alt) => {
    const mainImage = root.querySelector('.dbx-product-main-image');
    if (!mainImage || !src) return;
    mainImage.src = src;
    mainImage.srcset = '';
    if (alt) mainImage.alt = alt;
  };

  document.querySelectorAll('[data-dbx-product]').forEach((root) => {
    let variants = [];
    let currency = 'USD';

    try {
      variants = JSON.parse(root.querySelector('[data-dbx-variants]')?.textContent || '[]');
      currency = JSON.parse(root.querySelector('[data-dbx-currency]')?.textContent || '"USD"');
    } catch (_) {
      return;
    }

    root.querySelectorAll('[data-dbx-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        replaceMainImage(root, thumb.dataset.imageSrc, thumb.dataset.imageAlt);
        root.querySelectorAll('[data-dbx-thumb]').forEach((item) => {
          const current = item === thumb;
          item.classList.toggle('is-current', current);
          item.setAttribute('aria-pressed', current ? 'true' : 'false');
        });
      });
    });

    const optionInputs = Array.from(root.querySelectorAll('[data-dbx-option]'));
    if (!optionInputs.length || !variants.length) return;

    const updateVariant = () => {
      const selectedOptions = optionInputs.map((select) => select.value);
      const variant = variants.find((candidate) =>
        candidate.options.every((option, index) => option === selectedOptions[index])
      );

      const variantInput = root.querySelector('[data-dbx-variant-id]');
      const submit = root.querySelector('[data-dbx-submit]');
      const submitText = root.querySelector('[data-dbx-submit-text]');
      const price = root.querySelector('[data-dbx-price]');
      const compare = root.querySelector('[data-dbx-compare]');

      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, currency);
      if (compare) {
        const showCompare = Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !showCompare;
        compare.textContent = showCompare ? formatMoney(variant.compare_at_price, currency) : '';
      }
      if (submit) submit.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      if (variant.featured_image?.src) {
        replaceMainImage(root, variant.featured_image.src, variant.featured_image.alt || '');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionInputs.forEach((select) => select.addEventListener('change', updateVariant));
  });
})();
